import React from 'react'

// Origin and buyer chips, applied the moment they are clicked. Only what the
// response's filter_options offers is ever a chip, so a buyer name on this
// row always comes from the backend.
export default function InspectorFilters({ options, origins, buyers, onToggleOrigin, onToggleBuyer, onClear }) {
  const hasSelection = origins.length > 0 || buyers.length > 0
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <ChipRow label="Origin">
        {(options?.origins || []).map((o) => (
          <button key={o} type="button" className="li-chip" aria-pressed={origins.includes(o)} onClick={() => onToggleOrigin(o)}>
            {o}
          </button>
        ))}
      </ChipRow>
      <ChipRow label="Buyer">
        {(options?.buyers || []).map((b) => {
          const id = String(b.id)
          return (
            <button key={id} type="button" className="li-chip" aria-pressed={buyers.includes(id)} onClick={() => onToggleBuyer(id)}>
              {b.label}
            </button>
          )
        })}
      </ChipRow>
      {hasSelection && (
        <div>
          <button type="button" className="btn btn-ghost btn-sm" onClick={onClear}>Clear filters</button>
        </div>
      )}
    </div>
  )
}

function ChipRow({ label, children }) {
  const items = React.Children.toArray(children)
  return (
    <div role="group" aria-label={label} style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.04em', minWidth: 52 }}>
        {label}
      </span>
      {items.length ? items : <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>None in this data</span>}
    </div>
  )
}
